import {Boot} from '@/project'
import {InfiniteScroll, Loading, Message, MessageBox, Notification} from 'element-ui'

const boot: Boot = ({Vue}) => {
  Vue.use(Loading.directive)
  Vue.use(InfiniteScroll)
  Vue.prototype.$loading = Loading.service
  Vue.prototype.$msgbox = MessageBox
  Vue.prototype.$alert = MessageBox.alert
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$prompt = MessageBox.prompt
  Vue.prototype.$notify = Notification
  Vue.prototype.$message = Message
  Vue.prototype.$infiniteScroll = InfiniteScroll
}

export default boot
